/* eslint-disable */
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { shallow } from "zustand/shallow";

import { useFetchDataImmutable } from "../../../apiHelpers";
import useIntakeFormStore from "../../../store/IntakeForm.store";
import {
  trackCategorySelect,
  trackStrategySelect,
} from "../../../utils/helpers/analytics";
import { getStrategyDetailByName } from "../../../utils/helpers/intakeForm";
import Card from "../../Card";
import RadioButtonCustomBlend from "../../Form/RadioButtonCustomBlend";
import SelectInput from "../../Form/SelectInput";

import {
  API_ROUTES
} from "../../../constants";

const SelectStrategyCard = ({ id, headerIcon }) => {  
  const { data: sponsorData } = useFetchDataImmutable({
    url: API_ROUTES.SPONSOR_DETAIL,
  });
  
  const [formOptions, formState, formData] = useIntakeFormStore(
    (state) => [
      state.data.formOptions,
      state.data.formState,
      state.data.formData,
    ],
    shallow
  );

  const {
    handleSetIntakeFormOptionsSponsor
  } = useIntakeFormStore.getState().actions;

  useEffect(() => {
    if (sponsorData) {
      handleSetIntakeFormOptionsSponsor(sponsorData);
    }
  }, [
    sponsorData,
    formData
  ]);

  const [customIdexes, setCustomIndexes] = useState([]);
  const { handleSetIntakeFormStates } = useIntakeFormStore.getState().actions;
  const [strategyOptions, setStrategyOptions] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [showCustomBlend, setShowCustomBlend] = useState(false);
  const [isPredefinedCustomBlend, setIsPredefinedCustomBlend] = useState(false);
  const [configObj, setConfigObj] = useState(null);
  const [readOnlyConfigObj, setReadOnlyConfigObj] = useState(null);
  const [customBlend, setCustomBlend] = useState(null);

  const [savedLabel, setSavedLabel] = useState(null);

  const isLocked = formState.isFormLocked;

  const { control, setValue, getFieldState, getValues } = useFormContext();
  const categoryValue = useWatch({
    control,
    name: "selectCategory",
  });
  const strategyValue = useWatch({
    control,
    name: "selectStrategy",
  });

  const { isDirty, errors } = useFormState();

  useEffect(() => {
    if (formOptions.customBlend) {
      setCustomIndexes(formOptions.customBlend);
    }
  }, [formOptions.customBlend])

  useEffect(() => {
    if (categoryValue && isDirty) trackCategorySelect(categoryValue);
    const strategy = formOptions?.strategies[categoryValue] || [];

    setStrategyOptions(strategy);

    handleSetIntakeFormStates({
      category: categoryValue || null,
    });
  }, [categoryValue, handleSetIntakeFormStates, formOptions, isDirty]);

  useEffect(() => {
    if (strategyOptions.length > 0 && (formState && formState?.strategyCode || formData && formData?.strategyName)) {
      let selectedOption;
      if(formState?.strategyCode) {
        selectedOption =
          strategyOptions.find((opt) =>
            strategyValue
              ? opt.value === strategyValue
              : isFirstLoad && opt.value === formState?.strategyCode
          ) || null;

        if (selectedOption?.value === formState?.strategyCode) {
          setIsFirstLoad(false);
        }
      } else if(formData?.strategyName) {
        selectedOption =
          strategyOptions.find((opt) =>
            strategyValue
              ? opt.value === strategyValue
              : isFirstLoad && opt.label === formData?.strategyName
          ) || null;

        if (selectedOption?.label === formState?.strategyName) {
          setIsFirstLoad(false);
        }
      }
     

      setValue("selectStrategy", selectedOption?.value);

      if (!selectedOption) {
        setValue("selectStrategy", "");
      }

      const strategyDetail = getStrategyDetailByName(
        formOptions.strategyDetails,
        selectedOption?.label
      );

      if (strategyDetail && isDirty)
        trackStrategySelect(strategyDetail.strategyName);

      handleSetIntakeFormStates({
        strategyCode: selectedOption?.value || null,
        strategyDetail: strategyDetail || null
      });
    }
  }, [
    strategyOptions,
    strategyValue,
    formOptions,
    formData?.strategyName,
    formState?.strategyCode,
    handleSetIntakeFormStates,
    setValue,
    isDirty,
  ]);

  function floatToPercentage(floatValue, decimalPlaces = 2) {
    return `${Math.floor((floatValue * 100).toFixed(decimalPlaces))}`;
  }

  const formatObj = (isDefault, customBlend?) => {
    if(formOptions.customBlend) {
      const objArr = [];
      if(isDefault) {
        formOptions.customBlend.forEach((element) => (element.tplanCustomIndex === "SMArt Custom Blend (S&P, MSCI EAFE Default)") ? objArr.push(element) : null);
      } else {
        formOptions.customBlend.forEach((element) => (element.tplanCustomIndex === "SMArt Custom Blend") ? objArr.push(element) : null);
      }
      return (customBlend) ? generateCofigObj(objArr, customBlend) : generateCofigObj(objArr);
    }
  }

  function compareArraysByField(arr1, arr2, field) {
    if (arr1.length !== arr2.length) {
      return false;
    }
  
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i][field] !== arr2[i][field]) {
        return false;
      }
    }
  
    return true;
  }

  /* eslint-disable */
  const generateCofigObj = (objArr, customBlend?) => {
    const resultingOptionsArr = [];
    const splitObj = {};
    objArr.forEach((element, i) => {i = element.displayedBlendName, splitObj[i] ? splitObj[i].push(element) : (splitObj[i] = [element])}); // eslint-disable-line
    for(const key in splitObj) {
      const obj = splitObj[key];
      const label = key;
      let custBlendFields = [];
      const resultingCustomBlendFields = [];
      
      for(let i = 0; i < obj.length; i++) {
        const custBlendField = {
          displayedIndexName: obj[i].displayedIndexName,
          defaultWeight: obj[i].defaultWeight,
          extAcctCode: obj[i].extAcctCode,
        }
        custBlendFields.push(custBlendField);
      }

      if(customBlend){
        const parsedCustomBlend = JSON.parse(customBlend);
        const parsedCustomBlendArr = [];
        for(const item in parsedCustomBlend){
          const custItem = {
            defaultWeight: floatToPercentage(parsedCustomBlend[item]),
            extAcctCode: item
          }
          parsedCustomBlendArr.push(custItem);
        }
        
        if(compareArraysByField(custBlendFields, parsedCustomBlendArr, "extAcctCode")) {
          setSavedLabel(label);
          for(let i = 0; i < custBlendFields.length; i++) {
            if(custBlendFields[i].extAcctCode === parsedCustomBlendArr[i].extAcctCode) {
              const custField = {
                displayedIndexName: custBlendFields[i].displayedIndexName,
                defaultWeight: parsedCustomBlendArr[i].defaultWeight,
                extAcctCode: custBlendFields[i].extAcctCode,
              }
              resultingCustomBlendFields.push(custField);
            }
          }
          custBlendFields = resultingCustomBlendFields;
          
        }
        
      }
      
      const option = {
        label,
        value: label,
        custBlendFields,
      }
      resultingOptionsArr.push(option);
      updateStateOnce(customBlend);
      
    }
    return resultingOptionsArr;
  }
  /* eslint-enable */

  const updateStateOnce = (custBlend) => {
    let executed = false;
    return function() {
      if(!executed){
        executed = true;
        handleSetIntakeFormStates({
          customBlend: custBlend,
        });
      }
    }
  }

  useEffect(() => {
    if(!isLocked && strategyValue === "INDCBL") {
      const resultingOptionsArr = formatObj(false, formData?.customBlend);
      if(savedLabel) {
        setConfigObj({
          args: {
            type: "radio",
            name: "customBlend",
            label: "Custom Blend",// eslint-disable-line
            fieldIndex: 1,
            layout: "vertical",
            predefined: false,
            savedLabel,
            options: {
              readOnly: false,
              required: true,
              options: resultingOptionsArr,
            },
          },
        });
      } else {
        setConfigObj({
          args: {
            type: "radio",
            name: "customBlend",
            label: "Custom Blend",// eslint-disable-line
            fieldIndex: 1,
            layout: "vertical",
            predefined: false,
            options: {
              readOnly: false,
              required: true,
              options: resultingOptionsArr,
            },
          },
        });
      }
      setShowCustomBlend(true);
      setIsPredefinedCustomBlend(false);
    } else if(!isLocked && strategyValue === "INDCBL7030") {
      const resultingOptionsArr = formatObj(true);
      setConfigObj({
        args: {
          type: "radio",
          name: "customBlend",
          label: "Custom Blend",// eslint-disable-line
          fieldIndex: 1,
          layout: "vertical",
          predefined: true,
          options: {
            readOnly: false,
            required: true,
            options: resultingOptionsArr,
          },
        },
      });
      setShowCustomBlend(true);
      setIsPredefinedCustomBlend(true);
    } else {
      setShowCustomBlend(false);
      setIsPredefinedCustomBlend(false);
    } 
  }, [strategyValue, isLocked, formState, formData, savedLabel]);

  /* eslint-disable */
  useEffect(() => {
    if(isLocked && customIdexes && (formState.strategyCode === "INDCBL7030" || formState.strategyCode === "INDCBL")){
      if(formData?.customBlend){
        const obj = JSON.parse(formData?.customBlend);
        const resultingOptionsArr = [];
        const custBlendFields = [];
        for(const key in obj) {
          let displayedName = "";
          for(let i = 0; i < customIdexes.length; i++) {
            if(customIdexes[i].extAcctCode === key) {
              displayedName = customIdexes[i].displayedIndexName;
              break;
            }
          }
          const custBlendField = {
            displayedIndexName: displayedName,
            defaultWeight: floatToPercentage(obj[key]),
            extAcctCode: key,
          }
          custBlendFields.push(custBlendField);
        }
        const option = {
          label: 'test',
          value: null,
          custBlendFields
        }
        resultingOptionsArr.push(option);
        setReadOnlyConfigObj({
          args: {
            type: "radio",
            name: "customBlend",
            label: "Custom Blend",// eslint-disable-line
            fieldIndex: 1,
            layout: "vertical",
            predefined: true,
            options: {
              readOnly: false,
              required: true,
              options: resultingOptionsArr,
            },
          },
        })
      }
      setShowCustomBlend(true);
      setIsPredefinedCustomBlend(true);
    }
  }, [isLocked, formState, formData, customIdexes])
  /* eslint-enable */

  const handleDataFromChild = (data) => {
    setCustomBlend(data);
    handleSetIntakeFormStates({
      customBlend: data
    });
  }

  return (
    <Card
      id={id}
      title="Select Strategy"
      subtitle="Required Fields"
      headerIcon={headerIcon}
      openByDefault={true}
    >
      <div className="card__content">
        <SelectInput
          key="selectCategory"
          name="selectCategory"
          label="Asset style"
          options={{
            required: true,
            readOnly: isLocked,
            items: formOptions.categories || [],
          }}
        />
        <SelectInput
          key="selectStrategy"
          name="selectStrategy"
          label="Strategy"
          options={{
            required: true,
            disabled: typeof categoryValue === "undefined",
            readOnly: isLocked,
            items: strategyOptions,
          }}
        />
        {showCustomBlend && !isLocked && (
          <div>
            <div><h3>Select the Blend Option Below <span style={{fontSize: "0.75rem"}}>(Minimum weight is 10%)</span></h3></div>
            <div><RadioButtonCustomBlend sendDataToParent={handleDataFromChild} {...configObj.args} /></div>
          </div>
        )}
        {showCustomBlend && readOnlyConfigObj && isLocked && (
          <div>
            <div><RadioButtonCustomBlend sendDataToParent={function(){}} {...readOnlyConfigObj.args} /></div>
          </div>
        )}
        
      </div>
    </Card>
  );
};

SelectStrategyCard.propTypes = {
  id: PropTypes.string,
  headerIcon: PropTypes.string,
};

export default SelectStrategyCard;
